import React from 'react';

interface Page404Props {}

const Page404: React.FC<Page404Props> = ({ initialValue }) => {
  return (
    <div>
      <p>Counter: 12</p>
      <button>Increment</button>
    </div>
  );
};

export default Page404;